import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import { Animation } from "./components/Animation";

/** @deprecated */
export var ScrollContainer = Animation;

/** @deprecated */
var _default = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(_default, _React$PureComponent);
  var _super = _createSuper(_default);
  function _default() {
    var _this;
    _classCallCheck(this, _default);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return /*#__PURE__*/React.createElement(ScrollContainer, {
        className: _this.props.className,
        delay: _this.props.animationGutter,
        duration: _this.props.demoTransition,
        gutter: _this.props.gutter,
        handleShouldPlayDemo: _this.props.handleShouldPlayDemo,
        infiniteDemo: _this.props.infiniteDemo,
        onScroll: _this.props.onScroll,
        steps: _this.props.animationSteps,
        style: _this.props.style,
        "data-t-id": "components-ScrollContainer"
      }, _this.props.children);
    });
    return _this;
  }
  return _createClass(_default);
}(React.PureComponent);
_defineProperty(_default, "propTypes", {
  children: PropTypes.node,
  animationGutter: PropTypes.number,
  infiniteDemo: PropTypes.bool,
  demoTransition: PropTypes.number,
  animationSteps: PropTypes.oneOfType([PropTypes.array]),
  style: PropTypes.object,
  className: PropTypes.any,
  handleShouldPlayDemo: PropTypes.func,
  onScroll: PropTypes.func
});
export { _default as default };